import {globalVar} from 
    "./../../variables/global_variables.js";

import {checkIfItIsEmpty} from 
    "./../../functions/checks/checkIfItIsEmpty.js";

import {SmetioPreloader} from
    "./../../classes/smetioPreloader/SmetioPreloader.js";

import {SmetioAjax} from 
    "./../../classes/smetioAjax/SmetioAjax.js";

import {createForm} from
    "./createForm.js";

export async function retrieveSmetioForm(formId, publicKey, formContainer, ajaxErrorHolderClass, formSubmissionEndpoint ){

    globalVar["ajaxPreloader_"+formId] = new SmetioPreloader();
    globalVar["ajaxPreloader_"+formId].extra_attributes = `data-state="spinner_on_top"`; 
    globalVar["ajaxPreloader_"+formId].display_state = "show";

    const ajaxPreloader = globalVar["ajaxPreloader_"+formId].render();

    $(formContainer).html(ajaxPreloader);

    const smetioAjax = new SmetioAjax();

    smetioAjax.timeOut = 20000;

    smetioAjax.errorMsgHolder = formContainer;

    smetioAjax.dataToSendToServer =  {
        formId : formId, 
        formOwnerPublicKey: publicKey
    };
    
    smetioAjax.urlToConnectTo = globalVar.smetio_retrieveData_url+"getSmetioFormInputs/";

    smetioAjax.dataType = "json";
            
    smetioAjax.beforeSend = () => {
   
        /**** SHOW THE AJAX PRELOADER IF IT AVAILABLE ****/

        globalVar["ajaxPreloader_"+formId].loadStarted();

        /**** CALL THE CUSTOME BEFORE SEND FUNCTION IF IT IS NOT EMPTY ****/

        return true;
        
    };
    
    smetioAjax.success = async (result) => {

        /**** HIDE THE AJAX PRELOADER IF IT AVAILABLE ****/

        globalVar["ajaxPreloader_"+formId].loadComplete();

        if( checkIfItIsEmpty(result["form_details"]["submission_text"])){

            result["form_details"]["submission_text"] = "Next";

        };

        if( !checkIfItIsEmpty(formSubmissionEndpoint) ){

            result["form_details"]["submission_endpoint"] = formSubmissionEndpoint;

        }

        /*if( checkIfItIsEmpty(globalVar["smetioForm_"+formId]) ){

            globalVar["smetioForm_"+formId] = {};
        };*/

        //globalVar["smetioForm_"+formId] = {};
        globalVar["smetioForm_"+formId]["formId"] = formId;
        globalVar["smetioForm_"+formId]["inputs"] = result["input_details"];        
        globalVar["smetioForm_"+formId]["addPreloader"] = true;
        globalVar["smetioForm_"+formId]["formHolder"] = formContainer;
        globalVar["smetioForm_"+formId]["submissionBtnText"] = result["form_details"]["submission_text"];
        globalVar["smetioForm_"+formId]["ajaxUrl"] = result["form_details"]["submission_endpoint"];
        globalVar["smetioForm_"+formId]["dataToSendToServer"] = {};
        

        if( checkIfItIsEmpty(globalVar["smetioForm_"+formId]["ajaxBeforeSendFunc"]) ){
            
            globalVar["smetioForm_"+formId]["ajaxBeforeSendFunc"] = result["form_details"]["ajaxBeforeSendFunc"];
            
        };

        if( checkIfItIsEmpty(globalVar["smetioForm_"+formId]["ajaxSuccessFunc"]) ){
            
            globalVar["smetioForm_"+formId]["ajaxSuccessFunc"] = result["form_details"]["ajaxSuccessFunc"];

        };

        if( checkIfItIsEmpty(globalVar["smetioForm_"+formId]["ajaxErrorFunc"]) ){
            
            globalVar["smetioForm_"+formId]["ajaxErrorFunc"] = result["form_details"]["ajaxErrorFunc"];

        };        
        
                
        globalVar["smetioForm_"+formId]["ajaxErrorHolderClass"] = ajaxErrorHolderClass;

        let theForm = await createForm("smetioForm_"+formId);
        
        $(formContainer).prepend(theForm);

        console.log(globalVar["smetioForm_"+formId] );

    };    

    smetioAjax.error = (request, status, error) => {
            
        console.log(error);
        console.log(status);

        smetioAjax.defaultErrorMsg +=`<h5 class="smetioForm_${formId}_tryAgain">Try again</h5>`;

        smetioAjax.showErrorMessage(formContainer); 

        /**** HIDE THE AJAX PRELOADER IF IT AVAILABLE ****/

        globalVar["ajaxPreloader_"+formId].loadComplete();
   
        return false;
            
    };
    
    smetioAjax.sendRequest();

    $(".smetioForm_"+formId+"_tryAgain").click(function(){

        smetioAjax.sendRequest();

    });



};